/**
 * 判断是否是字符串或者字符串数组
 * @param {string|array|number} val
 * @return {boolean}
 */
export default function isStringOrStringArray(val) {
  if (Array.isArray(val)) {
    return val.every(item => typeof item === 'string')
  }

  return typeof val === 'string'
}
